export const RECEIVE_USER = 'RECEIVE_USER'
export const SET_ON_SUBMIT = 'SET_ON_SUBMIT'

export const SIDENAV_OPEN = 'SIDENAV_OPEN'
export const SIDENAV_CLOSE = 'SIDENAV_CLOSE'
export const SIDENAV_TOGGLE = 'SIDENAV_TOGGLE'
export const TOOLBAR_SET_TITLE = 'TOOLBAR_SET_TITLE'
export const TOOLBAR_SET_ACTION = 'TOOLBAR_SET_ACTION'
export const TOOLBAR_INIT_ACTION = 'TOOLBAR_INIT_ACTION'
export const TOOLBAR_START_PROCESSING = 'TOOLBAR_START_PROCESSING'
export const TOOLBAR_END_PROCESSING = 'TOOLBAR_END_PROCESSING'
export const TOOLBAR_SET_DATA = 'TOOLBAR_SET_DATA'

export const INTERCOM_SHOW = 'INTERCOM_SHOW'
export const INTERCOM_HIDE = 'INTERCOM_HIDE'
export const PRE_ROUTE_SAVE = 'PRE_ROUTE_SAVE'
export const VIEW_PENDING_START = 'VIEW_PENDING_START'
export const VIEW_PENDING_DONE = 'VIEW_PENDING_DONE'
export const VIEW_ERROR_CODE_SET = 'VIEW_ERROR_CODE_SET'
export const VIEW_STATE_INIT = 'VIEW_STATE_INIT'
export const SEARCH_INIT = 'SEARCH_INIT'
export const SEARCH_RECEIVE_KEY = 'SEARCH_RECEIVE_KEY'
export const NETWORK_SET = 'NETWORK_SET'
export const CLAIMS_SET = 'CLAIMS_SET'
export const USER_STATE_RESET = 'USER_STATE_RESET'
export const VALIDATOR_ERROR_SET = 'VALIDATOR_ERROR_SET'
export const ENTITLEMENTS_SET = 'ENTITLEMENTS_SET'
export const PURCHASES_CONFIGURE = 'PURCHASES_CONFIGURE'
export const PURCHASER_SET = 'PURCHASER_SET'
export const PLATFORM_SET = 'PLATFORM_SET'
export const ON_PAYMENT_SET = 'ON_PAYMENT_SET'
export const SET_OFFERINGS = 'SET_OFFERINGS'

export const AUTH_RESET = 'AUTH_RESET'
export const USER_INFO_RESET = 'USER_INFO_RESET'
export const HISTORY_RESET = 'HISTORY_RESET'
export const SEARCH_RESET = 'SEARCH_RESET'
export const META_RESET = 'META_RESET'
export const PURCHASES_RESET = 'PURCHASES_RESET'

export const SET_SERVICE_FETCHING = 'SET_SERVICE_FETCHING'
export const SET_SERVICE_UNLINKING = 'SET_SERVICE_UNLINKING'
export const COOLDOWN_SERVICE = 'COOLDOWN_SERVICE'

export const CHARTS_SET = 'CHARTS_SET'
export const CHARTS_BEGIN_FETCHING = 'CHARTS_BEGIN_FETCHING'
export const CHARTS_END_FETCHING = 'CHARTS_END_FETCHING'

export const SELECTION_EMPTY_DATA = 'SELECTION_EMPTY_DATA'
export const SELECTION_SET_DATA = 'SELECTION_SET_DATA'
export const SELECTION_START_PROCESSING = 'SELECTION_START_PROCESSING'
export const SELECTION_END_PROCESSING = 'SELECTION_END_PROCESSING'
export const SELECTION_START_SELECTING = 'SELECTION_START_SELECTING'
export const SELECTION_END_SELECTING = 'SELECTION_END_SELECTING'
